import { useState, useEffect } from 'react';
import spotlightService from '../services/SpotlightService';
import { useStreamAuth } from './useStreamAuth';

/**
 * Custom hook to fetch and manage user's purchased products
 * Uses v2/subscriptions/users/products for detailed transaction data
 * @returns {Object} Purchases data, subscription data, loading state, and error
 */
export const useMyPurchases = () => {
  const [purchasesData, setPurchasesData] = useState([]);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { isAuthenticated } = useStreamAuth();

  console.log('🛒 useMyPurchases: Hook initialized, isAuthenticated:', isAuthenticated);

  useEffect(() => {
    console.log('🛒 useMyPurchases: useEffect triggered, isAuthenticated:', isAuthenticated);
    
    const fetchPurchases = async () => {
      console.log('🛒 useMyPurchases: fetchPurchases called, isAuthenticated:', isAuthenticated);
      
      if (!isAuthenticated) {
        console.log('🛒 useMyPurchases: Not authenticated, skipping fetch');
        setLoading(false);
        setPurchasesData([]);
        setSubscriptionData(null);
        return;
      }

      console.log('🛒 useMyPurchases: User IS authenticated, proceeding with fetch...');

      try {
        setLoading(true);
        setError(null);

        console.log('🛒 useMyPurchases: About to call spotlightService.getTransactionHistory()...');
        const data = await spotlightService.getTransactionHistory();
        console.log('🛒 useMyPurchases: Transaction data fetched:', data);

        // Extract transactional purchases and subscription
        const purchases = data.transactional_purchases || [];
        const subscription = data.subscription || null;

        console.log('🛒 useMyPurchases: Purchases count:', purchases.length);
        console.log('🛒 useMyPurchases: Has subscription:', !!subscription);

        setPurchasesData(purchases);
        setSubscriptionData(subscription);
      } catch (err) {
        console.error('🛒 useMyPurchases: Error fetching purchases:', err);
        setError(err.message || 'Failed to load purchases');
        setPurchasesData([]);
        setSubscriptionData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPurchases();
  }, [isAuthenticated]);

  console.log('🛒 useMyPurchases: Returning data:', {
    purchasesData,
    subscriptionData,
    loading,
    error,
    purchaseCount: purchasesData.length
  });

  return {
    purchasesData,
    subscriptionData,
    loading,
    error,
  };
};

